import styled from 'styled-components';

export const SupportContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  text-align: center;
  background-color: #f9f9f9;
`;

export const SupportMessage = styled.p`
  font-size: 1.5rem;
  color: #333;
  a {
    color: #ff7f50;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;
